import React, { Component } from "react";
import { Provider } from "mobx-react";
import PropTypes from "prop-types";
import featuredItemStore from "../../stores/featuredItemStore";
import generalItemStore from "../../stores/generalItemStore";
import autoCompleteStore from "../../stores/autoCompleteStore";
import baseTagStore from "../../stores/baseTagStore";

class StoreProvider extends Component {
  render() {
    const { children } = this.props;
    return (
      <Provider
        featuredItemStore={featuredItemStore}
        generalItemStore={generalItemStore}
        autoCompleteStore={autoCompleteStore}
        baseTagStore={baseTagStore}
      >
        {children}
      </Provider>
    );
  }
}

StoreProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default StoreProvider;
